/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import PropTypes from 'prop-types';

export const HolderInfoProps = PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
});

export const HolderInfoDefaults = {
    first_name: '',
    last_name: '',
    phone_number: '',
};

export const PassInfoProps = PropTypes.shape({
    holder_info: HolderInfoProps,
    pass_name: PropTypes.string,
    holiday_season: PropTypes.bool,
    valid_from: PropTypes.string,
    valid_to: PropTypes.string,
});

export const PassInfoDefaults = {
    holder_info: HolderInfoDefaults,
    pass_name: '',
    holiday_season: false,
    valid_from: gnoment().format(),
    valid_to: gnoment().add(12, 'months').endOf('month').format(),
};
